import React from 'react';

const PR = () => {
    return (
        <main className="py-4 py-md-5" style={{ minHeight: '100vh' }}>
            <div className="container" style={{ maxWidth: '760px' }}>
                <div className="lg-glass lg-glass--section p-3">
                    <h1 className="mb-3">Presentaciones</h1>
                    <ul>
                        <li>
                            <a href="https://canva.link/tztko8kwqo1p7mm" target="_blank" rel="noopener noreferrer">
                                Presentación 1
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </main>
    );
};

export default PR;
